import { useState } from 'react'
import { donorService } from '@/services'

export const useUpdateDonor = () => {
  const [loadingUpdateDonor, setLoadingUpdateDonor] = useState(false)
  const updateDonor = async (donorId, formData) => {
    setLoadingUpdateDonor(true)
    try {
      const response = await donorService.updateDonor(donorId, formData)
      return response?.data
    } finally {
      setLoadingUpdateDonor(false)
    }
  }
  return { loadingUpdateDonor, updateDonor }
}

export const useConfirmAppointment = () => {
  const [loadingConfirmAppointment, setLoadingConfirmAppointment] =
    useState(false)

  const confirmAppointment = async payload => {
    setLoadingConfirmAppointment(true)
    try {
      const response = await donorService.confirmAppointment(payload)
      return response
    } finally {
      setLoadingConfirmAppointment(false)
    }
  }
  return { loadingConfirmAppointment, confirmAppointment }
}

export const useGetDonorAppointments = () => {
  const [loadingGetDonorAppointments, setLoadingGetDonorAppointments] =
    useState(true)

  const getDonorAppointments = async (
    donorId,
    showAll = false,
    loadingFlag = false
  ) => {
    if (loadingFlag) setLoadingGetDonorAppointments(true)
    try {
      const response = await donorService.getDonorAppointments(donorId, showAll)
      return response
    } finally {
      setLoadingGetDonorAppointments(false)
    }
  }
  return { loadingGetDonorAppointments, getDonorAppointments }
}

export const useCancelDonorAppointment = () => {
  const [loadingCancelDonorAppointment, setLoadingCancelDonorAppointment] =
    useState(false)

  const cancelDonorAppointment = async appointmentId => {
    setLoadingCancelDonorAppointment(true)
    try {
      const response = await donorService.cancelDonorAppointment(appointmentId)
      return response
    } finally {
      setLoadingCancelDonorAppointment(false)
    }
  }
  return { loadingCancelDonorAppointment, cancelDonorAppointment }
}

export const useRescheduleAppointment = () => {
  const [loadingRescheduleAppointment, setLoadingRescheduleAppointment] =
    useState(false)

  const rescheduleAppointment = async payload => {
    setLoadingRescheduleAppointment(true)
    try {
      const response = await donorService.rescheduleAppointment(payload)
      return response
    } finally {
      setLoadingRescheduleAppointment(false)
    }
  }
  return { loadingRescheduleAppointment, rescheduleAppointment }
}

export const useGetDonorHealthHistory = () => {
  const [loadingGetDonorHealthHistory, setLoadingGetDonorHealthHistory] =
    useState(false)

  const getDonorHealthHistory = async donorId => {
    setLoadingGetDonorHealthHistory(true)
    try {
      const response = await donorService.getDonorHealthHistory(donorId)
      return response
    } finally {
      setLoadingGetDonorHealthHistory(false)
    }
  }
  return { loadingGetDonorHealthHistory, getDonorHealthHistory }
}

export const useGetDonorBadges = () => {
  const [loadingGetDonorBadges, setLoadingGetDonorBadges] = useState(false)

  const getDonorBadges = async donorId => {
    setLoadingGetDonorBadges(true)
    try {
      const response = await donorService.getDonorBadges(donorId)
      return response
    } finally {
      setLoadingGetDonorBadges(false)
    }
  }
  return { loadingGetDonorBadges, getDonorBadges }
}

export const useLoyaltyAuth = () => {
  const [loadingLoyaltyAuth, setLoadingLoyaltyAuth] = useState(false)

  const getLoyaltyAuth = async params => {
    setLoadingLoyaltyAuth(true)
    try {
      const response = await donorService.getLoyaltyAuth(params)
      return response
    } finally {
      setLoadingLoyaltyAuth(false)
    }
  }
  return { loadingLoyaltyAuth, getLoyaltyAuth }
}
